
  import Events from '@/events/Events';
  import {hasRelevantDataForApplication} from '@/helper/ProfileCompletenessHelper';
  import ScreenSize from '@/mixins/ScreenSize';

  export default {
    name: 'ApplyOnJobPostingDialog',
    components: {
      ThankYouPage: () =>
        import('@/components/candidate/ApplyOnJobPostingDialog/ThankYouPage'),
      ApplyOnJobPostingForm: () =>
        import(
          '@/components/candidate/ApplyOnJobPostingDialog/ApplyOnJobPostingForm'
        ),
      UpdateBeforeApplicationForm: () =>
        import(
          '@/components/candidate/UpdateBeforeApplicationDialog/UpdateBeforeApplicationForm'
        ),
    },
    mixins: [ScreenSize],
    props: {
      job: {
        type: Object,
        required: true,
      },
      application: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      buttonClass: {
        type: String,
        required: false,
        default: '',
      },
      textButton: {
        type: Boolean,
        required: false,
        default: false,
      },
      blockButton: {
        type: Boolean,
        required: false,
        default: false,
      },
      topJob: {
        type: Boolean,
        default: false,
      },
      comeFrom: {
        type: String,
        required: true,
        default: 'detailPage',
      },
      applicationDialog: {
        type: Boolean,
        required: false,
        default: false,
      },
      width: {
        type: String,
        required: false,
        default: 'auto',
      },
      openDirectDialog: {
        type: String,
        required: false,
        default: '',
      },
      position: {
        type: String,
        required: false,
        default: 'NULL',
      },
    },
    data: () => ({
      dialog: false,
      dialogWidth: 900,
      page: null,
    }),
    computed: {
      hasApplication() {
        return Boolean(Object.keys(this.application).length > 0);
      },
    },
    created() {
      if (this.openDirectDialog && this.openDirectDialog !== '') {
        this.openDialog(this.openDirectDialog);
      }
    },
    mounted() {
      if (this.applicationDialog) {
        this.prepareInsideForm();
        this.dialog = true;
      }
    },
    methods: {
      openDialog(page) {
        this.dialog = true;
        this.dialogWidth = 900;
        this.page = page;
      },
      changePage(page) {
        if (page === 'thankYou') {
          this.$emitWithClientData(Events.ThankYouPageOpened, {
            type: 'JobApplication',
          });
        }
        this.page = page;
      },
      determinePage(on) {
        return ($event) => {
          on.click($event);
          this.prepareInsideForm();
        };
      },
      async prepareInsideForm() {
        this.page = null;
        this.$auth.fetchUser().then(async () => {
          if (
            await hasRelevantDataForApplication(
              this.$auth.user.candidateProfile
            )
          ) {
            this.page = 'applicationForm';
            this.$emitWithClientData(Events.JobApplicationOpened, {
              jobPostingId: this.job.id,
            });
          } else {
            this.page = 'updateAndApplicationForm';
            this.$emitWithClientData(Events.UpdateAndApplicationOpened, {
              jobPostingId: this.job.id,
            });
          }
        });
      },
    },
  };
